import { isNumber } from '@/EventLogic/util';

export default function (component, config) {
  if (!component.fieldset || !config.blockFieldsets[component.fieldset]) {
    return {
      fieldset: 'Please select a field.'
    };
  }

  if (!config.blockFieldsets[component.fieldset].numeric) {
    return validateMultipleChoice(component);
  }

  return validateNumeric(component);
}

function validateNumeric(component) {
  let errors = {};

  if (component.fieldsForDropdown && component.fieldsForDropdown.length > 1) {
    const found = component.fieldsForDropdown
      .filter(field => field.name == component.exportTag)
      .length > 0;
    if (!component.exportTag) {
      errors.exportTag = 'Please select a field to evaluate.'
    } else if (!found) {
      errors.exportTag = 'Invalid field selected.'
    }
  }

  if (!component.operator) {
    errors.operator = "Please select a comparison operator.";
  }
  if (component.amountortarget === "amount"
    && !isNumber(component.amount)
    && component.operatorIsNumeric
  ) {
    errors.amount = "Must provide a numeric value for this operator.";
  } else if ((component.amountortarget === "variable") && !component.variable) {
    errors.variable = "Must select a variable to compare against.";
  }
  // if it is a text operator AND is an empty string
  if (!component.operatorIsNumeric && component.operatorTakesArgs && !component.text) {
    errors.text = "Must insert a text value for this operator.";
  }

  return errors;
}

function validateMultipleChoice(component) {
  if (component.compliantChoices.length < 1) {
    return {
      compliantChoices: "Please select at least one valid choice."
    };
  }

  return {};
}
